import { Button, Tooltip } from 'antd';
import './MapButton.less';
import { useAppSelector } from '../../../store/hooks/hooks';
import { selectMapTutorial } from '../../../store/slice/mapSlice';
import { ComponentType, useState } from 'react';
import Icon from '@ant-design/icons';

interface Props {
  tooltip: string;
  onClick?: () => any;
  icon: ComponentType;
  active?: boolean;
  loading?: boolean;
  disabled?: boolean;
  disabledTooltipDescription?: string;
}

function MapButton({ tooltip, onClick, icon, active, loading, disabled, disabledTooltipDescription }: Props) {
  const mapTutorial = useAppSelector(selectMapTutorial);
  const [hover, setHover] = useState<boolean>(false);

  const disabledTooltipContent = disabledTooltipDescription ? (
    <div>
      <div> <b style={{fontWeight: 600}}>{tooltip}</b></div>
      <div>{disabledTooltipDescription}</div>
    </div>
  ) : tooltip;

  return (
    <Tooltip
      title={disabled ? disabledTooltipContent : tooltip}
      visible={mapTutorial ? true : hover}
      trigger={'hover'}
      placement={'left'}
    >
      <Button
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        loading={loading}
        //no usa el prop disabled del button, ya que rompe los tooltips
        className={'at-map-button__button ' + (active ? 'active ' : '') + (disabled ? 'disabled' : '')}
        size='large'
        shape='round'
        onClick={() => (mapTutorial || disabled ? null : onClick?.())}
        type={'ghost'}
        icon={<Icon component={icon} />}
      />
    </Tooltip>
  );
}

export default MapButton;
